const routePrefix = "/employee-complaint";
const attachment = `${routePrefix}/attachment`;

export default {
  getAllComplaintsByEmployeeId: (employeeId) => `${routePrefix}/${employeeId}`,
  getComplaintAttachment: (lookupKey) => `${attachment}/${lookupKey}`,
  postComplaintAttachment: (fileName) => `${attachment}/${fileName}`,
  postComplaint: () => `${routePrefix}`,
  getComplaintCategories: (employeeId) => `${routePrefix}/categories/employee/${employeeId}`
};